import React, { FunctionComponent, useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';

// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Common
import api from '../../../../api';
import { GENERAL } from '../../../../constants';
import { models, types } from '../../../../types';

// Components
import { Tile } from '../../../Tile';
import { FormRadioGroup } from '../FormInputs';

// Properties
import * as styles from './FormSubjects.styles';
import { ProgramType } from "../../../../types/types";

type TProps = {
    subjects: types.TBaseDictionaryField;
}

const FormSubjects: FunctionComponent<TProps> = ({
    subjects
}) => {
    const [ availableSubjects, setAvailableSubjects ] = useState(null);
    const [ availableSubjectsError, setAvailableSubjectsError ] = useState('');

    const { values: { schoolId, programId, subjectId } } = useFormikContext();

    const fetchAvailableSubjects = (model: models.TSubject) => {
        api.getSubject(model)
            .then(({ data }) => {
                setAvailableSubjects(data.data);
            })
            .catch(error => {
                setAvailableSubjectsError(error.message);
            });
    };

    useEffect(() => {
        if (!programId) {
            return;
        }
        const model: models.TSubject = {
            programId: programId,
        }
        fetchAvailableSubjects(model);
    }, [programId]);

    if (availableSubjectsError) {
        return (
            <Typography
                variant="body2"
                color="error"
            >
                {availableSubjectsError}
            </Typography>
        );
    }

    return (
        <Tile title={GENERAL.SUBJECTS_TITLE}>
            {!(schoolId && programId) &&
                <Box>
                    <Typography
                        variant="body2"
                        color="error"
                        gutterBottom
                    >
                        {GENERAL.SUBJECTS_DESCRIPTION}
                    </Typography>
                </Box>
            }
            {(programId === ProgramType.EGZAMIN_7 || programId === ProgramType.EGZAMIN_8) &&
                <Box>
                <Typography
                    variant="body2"
                    color="error"
                    gutterBottom
                    sx={styles.newLine}
                >
                    {!subjectId ? 'Wybierz przedmiot, którego uczysz. \n Niezależnie od Twojego wyboru będziesz mieć możliwość wpisania wyników \nz wszystkich części egzaminu – nie wypełniaj karty uczestnika kilkakrotnie.' : ''}
                </Typography>
            </Box>
            }
            <Box>
                <Field
                    name="subjectId"
                    options={subjects}
                    required
                    disabled={!(schoolId && programId)}
                    disabledOptions={availableSubjects}
                    component={FormRadioGroup}
                />
            </Box>
        </Tile>
    );
};

export default FormSubjects;
